import React from 'react';
import { Create, NumberInput, ReferenceInput, required, SelectInput, SimpleForm, TextInput } from 'react-admin';
import CityAutocompleteInput from '../../../../commonComponents/CityAutocompleteInput';
import LegalEntityAutocompleteInput from '../../../../commonComponents/LegalEntityAutocompleteInput';
import ManagerAutocompleteInput from '../../../../commonComponents/ManagerAutocompleteInput';
import { isCaucasus, isBelarus, isHungary } from '../../../../helpers/appTypeHelper';
import { outletsActivityStatusesOptions, outletsTMRCoverageOptions, roles } from '../../../../config/constants';

const OutletCreate = (props) => (
  <Create title="Edit Outlet" undoable={false} {...props}>
    <SimpleForm redirect="list">
      <TextInput label={isCaucasus ? 'Address' : 'Street'} source="street" sortable={false} validate={required()} />
      {!isCaucasus && (
        <TextInput label="Building Number" source="building_number" sortable={false} validate={required()} />
      )}
      {isCaucasus && <SelectInput label="TMR Coverage" source="tmr_coverage" choices={outletsTMRCoverageOptions} />}
      {isCaucasus && (
        <ManagerAutocompleteInput
          label="Supervisor"
          source="supervisor_id"
          filter={{ roles: [roles.RSM] }}
          validate={required()}
        />
      )}
      {isCaucasus && (
        <SelectInput
          label="Activity Status"
          source="status"
          choices={outletsActivityStatusesOptions}
          validate={required()}
        />
      )}
      {isCaucasus && <NumberInput label="Cluster" source="cluster" />}
      {isCaucasus && <TextInput label="Sub Chanel" source="sub_channel" />}
      {isCaucasus && <TextInput label="Region" source="area" />}
      <TextInput label="Longitude" source="longitude" />
      <TextInput label="Latitude" source="latitude" />
      {isBelarus() && <TextInput label="Область" source="area" />}
      <ManagerAutocompleteInput label={isCaucasus ? 'TMR' : 'Manager'} validate={required()} />
      <CityAutocompleteInput validate={required()} />
      <LegalEntityAutocompleteInput label={isCaucasus ? 'LegalName' : undefined} validate={required()} />
      <ReferenceInput source="outlet_type_id" reference="admin/services/outlet-types" validate={required()}>
        <SelectInput optionText="name" />
      </ReferenceInput>
      <TextInput label="Outlet code" source="outlet_code" />
      <TextInput label={isCaucasus ? 'Fiscal Code' : 'Legal ID'} source="legal_id" />
      {isHungary() && (
        <ReferenceInput label="Tier" source="tier_discount_id" reference="admin/tiers-discounts">
          <SelectInput optionText="name" />
        </ReferenceInput>
      )}
    </SimpleForm>
  </Create>
);

export default OutletCreate;
